import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {fromEvent, Subscription, BehaviorSubject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {trigger, state, style, transition, animate} from '@angular/animations';

@Component({
    selector: 'aria-scroll-button',
    templateUrl: './scroll-button.component.html',
    styleUrls: ['./scroll-button.component.scss'],
    animations: [
        trigger('fade', [
            state('fadeIn', style({opacity: 1, 'pointer-events': 'auto', transform: 'translateY(0)'})),
            transition('* => *', animate(300))
        ])
    ]
})
export class ScrollButtonComponent implements OnInit, OnDestroy {

    btnStatus$: BehaviorSubject<string> = new BehaviorSubject<string>('fadeOut');
    newHeight: number;
    lastHeight = 1;
    resizeSubscription: Subscription;
    eventsSubscription: Subscription;
    scrollSubscription: Subscription;

    constructor(private router: Router) {

        this.eventsSubscription = this.router.events
            .subscribe((event) => ((event instanceof NavigationEnd) ? this.initializeShowBtn : ''));

        this.resizeSubscription = fromEvent(window, 'resize')
            .pipe(debounceTime(400))
            .subscribe(e => {
                this.setShowButton();
            });
    }

    ngOnInit() {
        this.initializeShowBtn();
    }


    initializeShowBtn() {
        const body: any = document.body;
        this.lastHeight = this.lastHeight || body.clientHeight;
        this.newHeight = body.clientHeight;
        if (this.lastHeight !== this.newHeight) {
            this.setShowButton();
        }
        this.lastHeight = this.newHeight;
    }

    setShowButton() {
        const body: any = document.body, html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);

        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }

        if (window.innerHeight < height) {
            this.scrollSubscription = fromEvent(window, 'scroll')
                .pipe(debounceTime(100))
                .subscribe(e => {
                    this.btnStatus$.next(
                        (window.innerHeight < (body.scrollHeight)) && (window.scrollY > 100) ?
                            'fadeIn' : 'fadeOut'
                    );
                });
        }

    }

    resetPagePosition() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    ngOnDestroy() {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
        if (this.eventsSubscription) {
            this.eventsSubscription.unsubscribe();
        }
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }

}
